import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom'
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import appStore from './store/index';
import { AuthProvider, setEnv } from 'bxl-auth';
import 'bootstrap';

setEnv(process.env.REACT_APP_SERVER_ENV);

if (process.env.NODE_ENV !== 'production') {
  console.log('====================================');
  console.log('Looks like we are in development mode!');
  console.log('====================================');
}

ReactDOM.render((
    <Provider store={ appStore }>
      <Router>
          <AuthProvider>
              <App />
          </AuthProvider>
      </Router>
    </Provider>
), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
